/***************************************************************************
 * urlRegex - a regular expression that can be used to get various parts of
 * the url url = r[0]; protocol = r[2]; username = r[5]; password = r[7];
 * host = r[8] || ""; port = r[10]; pathname = r[11] || ""; querystring =
 * r[14] || ""; fragment = r[16] || "";
 **************************************************************************/
ht.urlRegex =
  /^((\w+):)?(\/\/((\w+)?(:(\w+))?@)?([^\/\?:]+)(:(\d+))?)?(\/?([^\/\?#][^\?#]*)?)?(\?([^#]+))?(#(\S*))?/;
